import {Component} from "../../../gvf/js/component";

export class ProductConfigFieldHelp extends Component{

    getVal(){
        return 0;
    }

    setVal(value,noEvent){
        this.$value.val("");
    }

    ready(){
        super.ready();
        this.$popup = this.$root.find(".js-popup");
        this.$popup.find(".js-popup__close").click(
            (ev)=>{
                ev.preventDefault();
                var iframes = $(".youtube-player");
                for(let i = 0;i<iframes.length;i++){
                    var src = $(iframes[i]).attr('src');
                    $(iframes[i]).attr('src', '').attr('src', src);
                }
                this.$popup.fadeOut();
            }
        );
        this.findMember("button").click(
            ()=>{
                this.$popup.fadeIn();
            }
        );
    }
}